import React from "react";

import { Subtitle } from "./styles";

interface TitleProps {
  children?: React.ReactNode;
}

export function SubtitleComponent({ children }: TitleProps) {
  return <Subtitle>{children}</Subtitle>;
}
